import { useRoutes } from "react-router-dom";
import { useEffect, useState, lazy } from "react";
import {
  buildUrl,
  getConFigData,
  getItem,
  isNotNullOrUndefined,
  modifyQuestions,
  removeItem,
  setItem,
  verifyDomain,
} from "services/utils";
import Loadable from "components/Loadable";
import LoginRoutes from "./LoginRoutes";
import MainRoutes from "./MainRoutes";
const Domain404 = Loadable(
  lazy(() => import("pages/maintenance/error/Domain404"))
);
import withRouter from "components/withRouter";
import { GET_DOCUMENT_NUMBERS } from "pages/DynamicDocument/utils/urlHelper";
import {
  GET_ASSIGNED_PROCEDURE,
  GET_DESCRIPTION_FOR_DOCUMENT_NUMBERS,
} from "services/url_helper";
import { getCustomizationDataByKey } from "services/customizationService";
import MaintenanceRoutes from "./MaintenanceRoutes";
import { setDateFormat } from "store/reducers/customizationDataSlice";
import { useDispatch } from "react-redux";

const ThemeRoutes = (props) => {
  const { userData, commonUrl, ApiServices, companyData, Constants } = props,
    { location } = props.router;
  const [isVerifiedDomain, setVerifiedDomain] = useState(false);
  const [loading, setLoading] = useState(true);
  // const [documentData, setDocumentData] = useState(
  //   getItem(Constants?.DOCUMENT_NUMBERS)
  // );
  const dispatch = useDispatch();

  const getDocumentNumbersData = async (clientQuestionsData) => {
    try {
      let uri = GET_DOCUMENT_NUMBERS;
      let result = await ApiServices.callServiceGet(uri);
      if (result?.data?.quality || result?.data?.procedure) {
        const allDocuments = [
          ...(result?.data?.quality || []),
          ...(result?.data?.procedure || []),
        ];
        const data = allDocuments?.map((item) => ({
          documentNumber: item?.number,
          documentName: item?.name,
          defaultName: item.defaultName,
          masterDocId: item.masterDocId,
        }));

        const updatedConfigData = {
          ...clientQuestionsData,
          documentNumbers: data,
        };

        await getAssignedProcedures(updatedConfigData);
      }
    } catch (error) {
      console.error("GET_ALL_CREATED_PROCEDURE API ERROR", error);
    }
  };

  const getAssignedProcedures = async (updatedConfigData) => {
    try {
      let uri = GET_ASSIGNED_PROCEDURE;
      let result = await ApiServices.callServiceGet(uri);

      const datas = result?.result?.data?.procedures || [];
      const updatedData = {
        ...updatedConfigData,
        assignProcedures: datas,
      };
      getDocumentNumberSequences(updatedData);
    } catch (error) {
      console.error("Error fetching standards:", error);
    }
  };
  const transformData = (data) => {
    return data?.reduce((acc, item) => {
      if (item?.prefixDescription && item?.prefixDescription.length > 0) {
        acc[item.prefixFor.replace(/\s+/g, "") + "Prefixes"] =
          item.prefixDescription
            ?.map((pd) => `${pd.prefix} - ${pd.prefixDescription}`)
            ?.join("\n");
      }
      return acc;
    }, {});
  };

  const getDocumentNumberSequences = async (updatedData) => {
    try {
      let reqObj = {
        moduleType: "docSequnce",
      };
      const uri = buildUrl(GET_DESCRIPTION_FOR_DOCUMENT_NUMBERS, reqObj);
      let result = await ApiServices.callServiceGet(uri);
      if (result?.result?.type === "success") {
        let requireData = result?.result?.data;
        const finalData = transformData(requireData);
        const updatedConfigData = {
          ...updatedData,
          ...finalData,
        };
        setItem(Constants?.CONFIGDATA, updatedConfigData);
      } else {
        const finalData = {};
        const updatedConfigData = {
          ...updatedData,
          ...finalData,
        };
        setItem(Constants?.CONFIGDATA, updatedConfigData);
      }
    } catch (error) {
      console.error("GET_ALL_CREATED_PROCEDURE API ERROR", error);
    }
  };

  const getDateFormate = async () => {
    try {
      const result = await getCustomizationDataByKey({
        selectField: "timeData",
      });
      if (result) {
        const { date, separator } = result?.timeData ?? "";
        const dateFormat = date?.join(separator);
        dispatch(setDateFormat(dateFormat));
        setItem(Constants.DATE_FORMATE, dateFormat, true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (
      // !isNotNullOrUndefined(getItem(Constants?.DOCUMENT_NUMBERS)) &&
      isNotNullOrUndefined(userData)
    ) {
      if (!Object.keys(getItem(Constants?.CONFIGDATA) || {})?.length > 0) {
        getQuestionByClient();
      }
      if (!getItem(Constants?.DATE_FORMATE)) {
        getDateFormate();
      }
      getDocumentNumbersData();
    }
  }, [userData]);

  const verifyDomainAsync = async () => {
    setLoading(true);
    try {
      const data = await verifyDomain();
      setLoading(false);

      if (data?.validDomain) {
        setVerifiedDomain(true);
        if (isNotNullOrUndefined(data?.data)) {
          setItem(Constants.KEY_COMPANY_DATA, data?.data);
        }
      } else {
        setVerifiedDomain(false);
        removeItem(Constants.KEY_COMPANY_DATA);
      }
    } catch (error) {
      console.error("verifyDomain Error=>", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isNotNullOrUndefined(companyData)) {
      verifyDomainAsync();
    }
  }, []);

  const getQuestionByClient = async () => {
    try {
      let reqObj = {
        standardName: "ISO13485",
        orgId: userData?.orgId,
      };
      let uri = commonUrl?.GET_CLIENT_QUESTION;
      let result = await ApiServices.callServicePostWithBodyData(uri, reqObj);
      if (result?.result?.type === "success") {
        let data = modifyQuestions(result?.result?.data, reqObj?.standard);
        let clientQuestionsData = getConFigData(data);
        await getDocumentNumbersData(clientQuestionsData);
      }
    } catch (error) {
      console.error("GET_CLIENT_QUESTION API ERROR", error);
    }
  };

  const routes = useRoutes([LoginRoutes, MainRoutes, MaintenanceRoutes]);

  useEffect(() => {
    const isPreservedRoute = () =>
      location?.pathname?.includes("/format") ||
      location?.pathname?.includes("/format-type-detail");

    return () => {
      if (!isPreservedRoute()) {
        removeItem(Constants.KEY_SIGNATURE_NAVIGATE_DATA);
      }
    };
  }, [location?.pathname]);

  if (loading) {
    return routes;
  } else if (isVerifiedDomain) {
    return routes;
  } else {
    return <Domain404 />;
  }
};

export default withRouter(ThemeRoutes);
